import type { AiManagedGroupEffectiveStatus } from "@adpilot/shared";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

export function ManagedGroupStatusBadge({
  status,
}: {
  status: AiManagedGroupEffectiveStatus;
}): React.ReactElement {
  const { t } = useTranslation("managedGroups");
  const variant = status === "active" ? "default" : status === "archived" ? "outline" : "secondary";
  return <Badge variant={variant}>{t(`status.${status}`)}</Badge>;
}
